export default __webpack_public_path__ + "media/images/icons/firefox-0ce8159b98768f809fb6208fc4281bff.png";